import * as S from './styled';
import { Col, Row } from 'react-bootstrap';
import { IFormPerfilFiscal } from '../../../../Pages/Cadastro/CadPerfilFiscal';
import Layout from '../../../data/Layout';
import { useEffect, useState } from 'react';
import ReactSelect from '../../../data/reactSelect';
import OptionsReactSelect from '../../../../interfaces/OptionsReactSelect';
import { notifyError } from '../../../notify/notify-component';
import Globals from '../../../../Globals.json';
import { InputDefault } from '../../../data/inputDefault';
import { useAppSelector } from '../../../../redux/store';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import InputCheckRadio from '../../../data/inputCheckRadio';
import { useCreateData } from '../../../../apiQuery/useCreateData';
import { useUpdateData } from '../../../../apiQuery/useUpdateData';
import { showError } from '../../../../apiQuery/toast';
import { useQueryFetchPages } from '../../../../apiQuery/useQueryFetchPages';
import { normalizeDescricao } from '../../../../utils/normalizeCaracters';
import { useQueryNcmByCodeOrDes } from '../../../../apiQuery/useQueryNcmByCodeOrDes';
import styles from '../../Produtos/FormProduto/styles.module.scss';
import { useFetchById } from '../../../../apiQuery/useFetchById';
import Loading from '../../../Loading/Loading';
import { queryClient } from '../../../../apiQuery/queryClient';
import NcmSelect from '../../../data/NcmSelect';

export default function FormPerfilFiscal({
  title,
  OnAddNewPerfilFiscal,
  editando,
  perfilFical,
}: IFormPerfilFiscal) {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);
  const createData = useCreateData(['taxProfile']);
  const updateData = useUpdateData(['taxProfile']);
  
  const {
    data: taxProfileByUuidFetch,
    isLoading: isLoadingProductById,
    isError: isErrorProductById,
  } = useFetchById<any>(
    'taxProfile',
    `${Globals.api.taxProfile}`,
    perfilFical?.uuid,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
      },
    }
  );
  const taxProfileByUuid = taxProfileByUuidFetch?.data;

  const {
    data: states,
    isLoading: isLoadingStates,
    isError: isErrorStates,
  } = useQueryFetchPages<any>(['states'], `${Globals.api.states}`, {
    queryParams: {
      store_id: storeMe?.storeActive?.id,
      paginate: false,
    },
  });

  const {
    data: invoiceTypes,
    isLoading: isLoadingInvoiceTypes,
    isError: isErrorInvoiceTypes,
  } = useQueryFetchPages<any>(
    ['invoiceTypes'],
    `${Globals.api.taxes}/invoices-types`,
    {
      queryParams: {
        paginate: false,
      },
    }
  );

  const {
    data: cstOrigins,
    isLoading: isLoadingCstOrigins,
    isError: isErrorCstOrigins,
  } = useQueryFetchPages<any>(
    ['cstOrigins'],
    `${Globals.api.taxes}/cst-origins`,
    {
      queryParams: {
        paginate: false,
      },
    }
  );

  const {
    data: cests,
    isLoading: isLoadingCests,
    isError: isErrorCests,
  } = useQueryFetchPages<any>(['cests'], `${Globals.api.taxes}/cests`, {
    queryParams: {
      paginate: false,
    },
  });

  const {
    data: cfops,
    isLoading: isLoadingCfops,
    isError: isErrorCfops,
  } = useQueryFetchPages<any>(['cfops'], `${Globals.api.taxes}/cfop`, {
    queryParams: {
      paginate: false,
    },
  });

  const {
    data: icmsCustomerTypes,
    isLoading: isLoadingIcmsCustomerTypes,
    isError: isErrorIcmsCustomerTypes,
  } = useQueryFetchPages<any>(
    ['icmsCustomerTypes'],
    `${Globals.api.taxes}/icms-customer-types`,
    {
      queryParams: {
        paginate: false,
      },
    }
  );

  const {
    data: cstReasonsList,
    isLoading: isLoadingCstReasons,
    isError: isErrorCstReasons,
  } = useQueryFetchPages<any>(
    ['cstReasons'],
    `${Globals.api.taxes}/cst-reasons`,
    {
      queryParams: {
        paginate: false,
      },
    }
  );

  // ========================================
  // QUERIES SEPARADAS PARA CADA TIPO DE CST
  // ========================================
  
  // CSTs de ICMS
  const {
    data: cstsIcms,
    isLoading: isLoadingCstsIcms,
    isError: isErrorCstsIcms,
  } = useQueryFetchPages<any>(
    ['csts-icms'],
    `${Globals.api.taxes}/csts`,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
        type: 'ICMS',
      },
    }
  );

  // CSTs de CSOSN
  const {
    data: cstsCSOSN,
    isLoading: isLoadingCstsCSOSN,
    isError: isErrorCstsCSOSN,
  } = useQueryFetchPages<any>(
    ['csts-CSOSN'],
    `${Globals.api.taxes}/csts`,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
        type: 'CSOSN',
      },
    }
  );

  // CSTs de IPI
  const {
    data: cstsIpi,
    isLoading: isLoadingCstsIpi,
    isError: isErrorCstsIpi,
  } = useQueryFetchPages<any>(
    ['csts-ipi'],
    `${Globals.api.taxes}/csts`,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
        type: 'IPI',
      },
    }
  );

  // CSTs de PIS
  const {
    data: cstsPis,
    isLoading: isLoadingCstsPis,
    isError: isErrorCstsPis,
  } = useQueryFetchPages<any>(
    ['csts-pis'],
    `${Globals.api.taxes}/csts`,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
        type: 'PIS',
      },
    }
  );

  // CSTs de COFINS
  const {
    data: cstsCofins,
    isLoading: isLoadingCstsCofins,
    isError: isErrorCstsCofins,
  } = useQueryFetchPages<any>(
    ['csts-cofins'],
    `${Globals.api.taxes}/csts`,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
        type: 'COFINS',
      },
    }
  );

  // Listas separadas para cada tipo
  const CSOSNList = cstsCSOSN?.data || [];
  const icmsList = cstsIcms?.data || [];
  const ipisList = cstsIpi?.data || [];
  const pisList = cstsPis?.data || [];
  const cofinsList = cstsCofins?.data || [];

  const [taxName, setTaxName] = useState<string>(
    editando && taxProfileByUuid ? taxProfileByUuid.tax_profile_name : ''
  );
  const [weight, setWeight] = useState<string>(
    editando && taxProfileByUuid ? taxProfileByUuid.tax_weight.toString() : '0'
  );
  const [types, setTypes] = useState<number | undefined>(
    editando && taxProfileByUuid
      ? taxProfileByUuid.relationships.tax_invoice_type?.id
      : undefined
  );
  const [origins, setOrigins] = useState<number | undefined>(
    editando && taxProfileByUuid
      ? taxProfileByUuid.relationships.cst_origin?.id
      : undefined
  );
  const [ncm, setNcm] = useState<number | undefined>(
    editando && taxProfileByUuid
      ? taxProfileByUuid.relationships.ncm?.id
      : undefined
  );

  const [cest, setCest] = useState<number | undefined>(
    editando && taxProfileByUuid
      ? taxProfileByUuid.relationships.cest?.id
      : undefined
  );
  const [cfop, setCfop] = useState<number | undefined>(
    editando && taxProfileByUuid
      ? taxProfileByUuid.relationships.cfop?.id
      : undefined
  );
  const [stateOrigin, setStateOrigin] = useState<number | undefined>(
    editando && taxProfileByUuid
      ? taxProfileByUuid.relationships.icms_origin_state?.id
      : undefined
  );
  const [stateDestiny, setStateDestiny] = useState<number | undefined>(
    editando && taxProfileByUuid
      ? taxProfileByUuid.relationships.icms_destiny_state?.id
      : undefined
  );
  const [customer, setCustomer] = useState<number | undefined>(
    editando && taxProfileByUuid
      ? taxProfileByUuid.relationships.icms_customer_type?.id
      : undefined
  );
  const [icms, setIcms] = useState<number | undefined>(
    editando && taxProfileByUuid
      ? taxProfileByUuid.relationships.cst_icms?.id
      : undefined
  );

  const [cstReasons, setCstReasons] = useState<number | undefined>(
    editando && taxProfileByUuid
      ? taxProfileByUuid.relationships.cst_ipi_reason?.id
      : 129
  );
  const [pis, setPis] = useState<number | undefined>(
    editando && taxProfileByUuid
      ? taxProfileByUuid.relationships.cst_pis?.id
      : undefined
  );
  const [cofins, setCofins] = useState<number | undefined>(
    editando && taxProfileByUuid
      ? taxProfileByUuid.relationships.cst_cofins?.id
      : undefined
  );
  const [aliquot, setAliquotIcms] = useState<string>(
    editando && taxProfileByUuid
      ? taxProfileByUuid.icms_aliquot.toString()
      : '0'
  );
  const [mva, setMva] = useState<string>(
    editando && taxProfileByUuid ? taxProfileByUuid.icms_mva.toString() : '0'
  );
  const [reduction, setReduction] = useState<string>(
    editando && taxProfileByUuid
      ? taxProfileByUuid.icms_base_calc_reduction.toString()
      : '0'
  );
  const [icmsAliquotDeferral, setIcmsAliquotDeferral] = useState<string>(
    editando && taxProfileByUuid
      ? taxProfileByUuid.icms_aliquot_deferral.toString()
      : '0'
  );
  const [icmsCredit, setIcmsCredit] = useState<string>(
    editando && taxProfileByUuid ? taxProfileByUuid.icms_credit.toString() : '0'
  );
  const [aliquotIpi, setAliquotIpi] = useState<string>(
    editando && taxProfileByUuid ? taxProfileByUuid.ipi_aliquot.toString() : '0'
  );
  const [aliquotPis, setAliquotPis] = useState<string>(
    editando && taxProfileByUuid ? taxProfileByUuid.pis_aliquot.toString() : '0'
  );
  const [aliquotCofins, setAliquotCofins] = useState<string>(
    editando && taxProfileByUuid
      ? taxProfileByUuid.cofins_aliquot.toString()
      : '0'
  );

  const [ipi, setIpi] = useState<number | undefined>(
    editando && taxProfileByUuid
      ? taxProfileByUuid.relationships.cst_ipi?.id
      : undefined
  );
  const [icmsOpen, setIcmsOpen] = useState(false);

  const [validTaxName, setValidTaxName] = useState<boolean>(false);

  const [validNcm, setValidNcm] = useState<boolean>(false);
  const [validCfop, setValidCfop] = useState<boolean>(false);
  const [validIcms, setValidIcms] = useState<boolean>(false);
  const [validAliquotCofins, setValidAliquotCofins] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [validAliquot, setValidAliquot] = useState<boolean>(false);
  const [validAliquotIpi, setValidAliquotIpi] = useState<boolean>(false);
  const [validIpi, setValidIpi] = useState<boolean>(false);
  const [validPis, setValidPis] = useState<boolean>(false);
  const [validCofins, setValidCofins] = useState<boolean>(false);
  const [validAliquotPis, setValidAliquotPis] = useState<boolean>(false);
  const [objetNCM, setObjetNCM] = useState<any[]>([]);
  const [cestListObject, setCestListObject] = useState<OptionsReactSelect[]>(
    []
  );
  const [ncm_origin, setNcm_origin] = useState<string>(
    editando && taxProfileByUuid ? taxProfileByUuid?.ncm_origin : 'Nacional'
  );

  const handleCancel = () => {
    OnAddNewPerfilFiscal(false);
    cleanInputs();
  };

  const cleanInputs = () => {
    setTaxName('');
    setStateOrigin(undefined);
    setStateDestiny(undefined);
    setTypes(undefined);
    setOrigins(undefined);
    setNcm(undefined);
    setCest(undefined);
    setCfop(undefined);
    setCustomer(undefined);
    setIcms(undefined);
    setIpi(undefined);
    setCstReasons(129);
    setPis(undefined);
    setCofins(undefined);
    setWeight('0');
    setAliquotIcms('0');
    setMva('0');
    setReduction('0');
    setIcmsAliquotDeferral('0');
    setIcmsCredit('0');
    setAliquotIpi('0');
    setAliquotPis('0');
    setAliquotCofins('0');
    setNcm_origin('');
  };

  const handleValidete = () => {
    if (!taxName) setValidTaxName(true);
    if (taxName) setValidTaxName(false);

    if (!ncm) setValidNcm(true);
    if (ncm) setValidNcm(false);
    if (!cfop) setValidCfop(true);
    if (cfop) setValidCfop(false);
    if (!icms) setValidIcms(true);
    if (icms) setValidIcms(false);
    if (!aliquotCofins) setValidAliquotCofins(true);
    if (aliquotCofins) setValidAliquotCofins(false);
    if (!aliquot) setValidAliquot(true);
    if (aliquot) setValidAliquot(false);
    if (!ipi) setValidIpi(true);
    if (ipi) setValidIpi(false);
    if (!aliquotIpi) setValidAliquotIpi(true);
    if (aliquotIpi) setValidAliquotIpi(false);
    if (!pis) setValidPis(true);
    if (pis) setValidPis(false);
    if (!cofins) setValidCofins(true);
    if (cofins) setValidCofins(false);
    if (!aliquotPis) setValidAliquotPis(true);
    if (aliquotPis) setValidAliquotPis(false);

    if (
      ncm &&
      cfop &&
      icms &&
      aliquot &&
      aliquotCofins &&
      ipi &&
      aliquotIpi &&
      pis &&
      aliquotPis &&
      cofins
    ) {
      return true;
    }

    return false;
  };

  const handleSubmit = async () => {
    const valid = handleValidete();

    if (!valid) {
      notifyError('Por favor preencha todos os campos obrigatórios....');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const data = {
      uuid: taxProfileByUuid?.uuid || null,
      store_id: storeMe?.storeActive?.id,
      tax_profile_name: taxName,
      tax_invoice_type_id: types,
      cst_origin_id: origins,
      ncm_id: ncm,
      cfop_id: cfop,
      cest_id: cest,
      cst_icms_id: icms,
      icms_origin_state_id: stateOrigin,
      icms_destiny_state_id: stateDestiny,
      icms_customer_type_id: customer,
      cst_ipi_id: ipi,
      cst_ipi_reason_id: cstReasons,
      ...(pis && { cst_pis_id: pis }),
      ...(cofins && { cst_cofins_id: cofins }),
      tax_weight: weight ? parseFloat(weight) : 0,
      icms_aliquot: aliquot ? parseFloat(aliquot) : 0,
      icms_credit: icmsCredit ? parseFloat(icmsCredit) : 0,
      icms_mva: mva ? parseFloat(mva) : 0,
      icms_base_calc_reduction: reduction ? parseFloat(reduction) : 0,
      icms_aliquot_deferral: icmsAliquotDeferral
        ? parseFloat(icmsAliquotDeferral)
        : 0,
      ipi_aliquot: aliquotIpi ? parseFloat(aliquotIpi) : 0,
      pis_aliquot: aliquotPis ? parseFloat(aliquotPis) : 0,
      cofins_aliquot: aliquotCofins ? parseFloat(aliquotCofins) : 0,
      ncm_origin: ncm_origin,
    };

    setLoading(true);
    if (data.uuid) {
      console.log('update');

      updateData.mutate(
        {
          endpoint: Globals.api.taxProfile,
          id: data.uuid,
          payload: data,
        },
        {
          onSuccess: () => {
            handleCancel();
            queryClient.invalidateQueries({
              predicate: (query) => query.queryKey[0] === 'taxProfile',
            });
            setLoading(false);
          },
          onError: () => {
            setLoading(false);
          },
        }
      );
    } else {
      console.log('create');

      createData.mutate(
        {
          endpoint: Globals.api.taxProfile,
          payload: data,
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({
              predicate: (query) => query.queryKey[0] === 'taxProfile',
            });
            setLoading(false);
            handleCancel();
          },
          onError: () => {
            setLoading(false);
          },
        }
      );
    }
  };

  useEffect(() => {
    if (ncm) setValidNcm(false);
    if (cfop) setValidCfop(false);
    if (icms) setValidIcms(false);
    if (validAliquotCofins) setValidAliquotCofins(false);
    if (aliquot) setValidAliquot(false);
    if (ipi) setValidIpi(false);
    if (aliquotIpi) setValidAliquotIpi(false);
    if (pis) setValidPis(false);
    if (cofins) setValidCofins(false);
    if (aliquotPis) setValidAliquotPis(false);
  }, [
    ncm,
    cfop,
    icms,
    aliquot,
    aliquotIpi,
    cofins,
    pis,
    aliquotPis,
    origins,
    types,
    ipi,
    validAliquotCofins,
  ]);

  useEffect(() => {
    if (
      stateOrigin ||
      stateDestiny ||
      customer ||
      mva !== '0' ||
      icmsAliquotDeferral !== '0' ||
      icmsCredit !== '0' ||
      reduction !== '0'
    ) {
      setIcmsOpen(true);
    }
  }, []);

  if (isLoadingProductById) return <Loading />;

  return (
    <>
      <Layout
        title={title}
        isEditable={editando}
        onClickSave={handleSubmit}
        onClickEdit={handleSubmit}
        onClickCancel={handleCancel}
        loading={loading}
      >
        <S.Wrapper>
          <InputDefault
            label="Nome"
            type="text"
            autoComplete="off"
            state={taxName}
            placeholder="Nome"
            maxLength={50}
            setState={setTaxName}
            isInvalid={validTaxName}
          />
          <InputDefault
            label="Peso"
            placeholder="0,00 Kg"
            type="number"
            autoComplete="off"
            step="0.01"
            min="0"
            state={weight}
            setState={setWeight}
          />

          <ReactSelect
            label="Tipo"
            placeholder="Tipo"
            isClearable
            options={invoiceTypes?.data?.map((item: any) => ({
              value: item.id,
              label: item.tax_invoice_type_description,
              store_id: item.store_id,
            }))}
            state={types}
            setState={setTypes}
            isLoading={isLoadingInvoiceTypes}
            isDisabled={isLoadingInvoiceTypes}
          />

          <ReactSelect
            label="Origem"
            placeholder="Selecione a origem"
            isClearable
            options={cstOrigins?.data?.map((item: any) => ({
              value: item.id,
              label: item.cst_origin_description,
              store_id: item.store_id,
            }))}
            state={origins}
            setState={setOrigins}
            isLoading={isLoadingCstOrigins}
            isDisabled={isLoadingCstOrigins}
          />

          <NcmSelect
            label="NCM"
            state={ncm}
            setState={setNcm}
            placeholder="Pesquise seu NCM"
            isInvalid={validNcm}
            cests={cests}
            cest={cest}
            setCestListObject={setCestListObject}
          />
          {cestListObject?.length > 0 && (
            <ReactSelect
              label="CEST"
              placeholder="CEST"
              isClearable
              options={cestListObject?.map((item: any) => ({
                value: item?.id,
                label: item?.cest_code,
              }))}
              state={cest}
              setState={setCest}
              isLoading={isLoadingCests}
              isDisabled={isLoadingCests}
            />
          )}
          <ReactSelect
            label="CFOP"
            placeholder="CFOP"
            isClearable
            options={cfops?.data?.map((item: any) => ({
              value: item.id,
              label: `${item.cfop} - ${normalizeDescricao(
                item.descricao_cfop
              )}`,
              store_id: item.store_id,
            }))}
            state={cfop}
            setState={setCfop}
            isInvalid={validCfop}
            isLoading={isLoadingCfops}
            isDisabled={isLoadingCfops}
          />
        </S.Wrapper>

        <span
          style={{ fontWeight: 'bold', padding: '0 20px', fontSize: '13px' }}
        >
          Origem do NCM
        </span>
        <S.Wrapper4>
          <InputCheckRadio
            text="Nacional"
            value="Nacional"
            state={ncm_origin}
            setState={setNcm_origin}
          />
          <InputCheckRadio
            text="Importado"
            value="Importado"
            state={ncm_origin}
            setState={setNcm_origin}
          />
          <InputCheckRadio
            text="Estatal"
            value="Estatal"
            state={ncm_origin}
            setState={setNcm_origin}
          />
          <InputCheckRadio
            text="Municipal"
            value="Municipal"
            state={ncm_origin}
            setState={setNcm_origin}
          />
        </S.Wrapper4>

        <div className={styles.line} />

        <Row className="mb-2">
          <Col
            className="spaceBetween"
            style={{ cursor: 'pointer', paddingRight: '1rem' }}
            onClick={() => setIcmsOpen(!icmsOpen)}
          >
            <h4>Criar Regra ICMS</h4>
            <div>
              {!icmsOpen ? (
                <IoIosArrowDown size={20} />
              ) : (
                <IoIosArrowUp size={20} />
              )}
            </div>
          </Col>
        </Row>
        {icmsOpen && (
          <>
            <S.Wrapper>
              <ReactSelect
                label="Origem"
                placeholder="UF"
                isClearable
                options={states?.data?.map((item: any) => ({
                  value: item.id,
                  label: item.state_initials,
                  store_id: item.store_id,
                }))}
                state={stateOrigin}
                setState={setStateOrigin}
                isLoading={isLoadingStates}
                isDisabled={isLoadingStates}
              />

              <ReactSelect
                label="Destino"
                placeholder="UF"
                isClearable
                options={states?.data?.map((item: any) => ({
                  value: item.id,
                  label: item.state_initials,
                  store_id: item.store_id,
                }))}
                state={stateDestiny}
                setState={setStateDestiny}
                isLoading={isLoadingStates}
                isDisabled={isLoadingStates}
              />

              <ReactSelect
                label="Tip. cliente"
                placeholder="Tipo de cliente"
                isClearable
                options={icmsCustomerTypes?.data?.map((item: any) => ({
                  value: item.id,
                  label: item.icms_customer_type_description,
                  store_id: item.store_id,
                }))}
                state={customer}
                setState={setCustomer}
                isLoading={isLoadingIcmsCustomerTypes}
                isDisabled={isLoadingIcmsCustomerTypes}
              />

              <InputDefault
                label="MVA"
                placeholder="0,00"
                type="number"
                autoComplete="off"
                step="0.01"
                min="0"
                state={mva}
                setState={setMva}
              />

              <InputDefault
                label="Diferimento"
                placeholder="0,00"
                type="number"
                autoComplete="off"
                step="0.01"
                min="0"
                state={icmsAliquotDeferral}
                setState={setIcmsAliquotDeferral}
              />

              <InputDefault
                label="Cálc. crédito"
                placeholder="0,00"
                type="number"
                autoComplete="off"
                step="0.01"
                min="0"
                state={icmsCredit}
                setState={setIcmsCredit}
              />

              <InputDefault
                label="Redu. calculo"
                placeholder="0,00"
                type="number"
                autoComplete="off"
                step="0.01"
                min="0"
                state={reduction}
                setState={setReduction}
              />
            </S.Wrapper>
          </>
        )}

        <div className={styles.line} />

        <Row className="mb-2">
          <Col className="spaceBetween">
            <h4>IPI</h4>
          </Col>
        </Row>

        <S.Wrapper>
          <ReactSelect
            label="Sit. tributária"
            placeholder="Situação tributária"
            isClearable
            options={ipisList?.map((item: any) => ({
              value: item.id,
              label: `${item.cst_code} - ${item.cst_description}`,
              store_id: item.store_id,
            }))}
            state={ipi}
            setState={setIpi}
            isInvalid={validIpi}
            isLoading={isLoadingCstsIpi}
            isDisabled={isLoadingCstsIpi}
          />

          <InputDefault
            label="Aliq. IPI"
            placeholder="0,00"
            type="number"
            autoComplete="off"
            step="0.01"
            min="0"
            state={aliquotIpi}
            setState={setAliquotIpi}
            isInvalid={validAliquotIpi}
          />

          <ReactSelect
            label="Enqu.de IPI"
            placeholder="Enquadramento de ipi"
            isClearable
            options={cstReasonsList?.data?.map((item: any) => ({
              value: item.id,
              label: `${item.reason_code} - ${item.reason_description}`,
              store_id: item.store_id,
            }))}
            state={cstReasons}
            setState={setCstReasons}
            isLoading={isLoadingCstReasons}
            isDisabled={isLoadingCstReasons}
          />
        </S.Wrapper>

        <div className={styles.line} />

        <Row className="mb-2">
          <Col className="spaceBetween">
            <h4>PIS e COFINS</h4>
          </Col>
        </Row>

        <S.Wrapper2>
          {/* SELECT DE PIS - Agora usando pisList filtrado */}
          <ReactSelect
            label="CST PIS"
            placeholder="Selecione o CST de PIS"
            isClearable
            options={pisList?.map((item: any) => ({
              value: item.id,
              label: `${item.cst_code} - ${item.cst_description}`,
              store_id: item.store_id,
            }))}
            state={pis}
            setState={setPis}
            isInvalid={validPis}
            isLoading={isLoadingCstsPis}
            isDisabled={isLoadingCstsPis}
          />

          <InputDefault
            label="Alíquota PIS"
            placeholder="0,00"
            type="number"
            autoComplete="off"
            step="0.01"
            min="0"
            state={aliquotPis}
            setState={setAliquotPis}
            isInvalid={validAliquotPis}
          />

          {/* SELECT DE COFINS - Agora usando cofinsList filtrado */}
          <ReactSelect
            label="CST COFINS"
            placeholder="Selecione o CST de COFINS"
            isClearable
            options={cofinsList?.map((item: any) => ({
              value: item.id,
              label: `${item.cst_code} - ${item.cst_description}`,
              store_id: item.store_id,
            }))}
            state={cofins}
            setState={setCofins}
            isInvalid={validCofins}
            isLoading={isLoadingCstsCofins}
            isDisabled={isLoadingCstsCofins}
          />

          <InputDefault
            label="Alíquota COFINS"
            placeholder="0,00"
            type="number"
            autoComplete="off"
            step="0.01"
            min="0"
            state={aliquotCofins}
            setState={setAliquotCofins}
          />

          {/* SELECT DE ICMS/CSOSN - Agora usando CSOSNList */}
          <ReactSelect
            label="CST/CSOSN"
            placeholder="CSOSN (Código de situação de operação do Simples Nacional)"
            isClearable
            options={CSOSNList?.map((item: any) => ({
              value: item.id,
              label: `${item.cst_code} - ${item.cst_description}`,
              store_id: item.store_id,
            }))}
            state={icms}
            setState={setIcms}
            isInvalid={validIcms}
            isLoading={isLoadingCstsCSOSN}
            isDisabled={isLoadingCstsCSOSN}
          />

          <InputDefault
            label="Alíquota ICMS"
            placeholder="Alíquota do ICMS do Simples Nacional"
            type="number"
            autoComplete="off"
            step="0.01"
            min="0"
            state={aliquot}
            setState={setAliquotIcms}
            isInvalid={validAliquot}
          />
        </S.Wrapper2>
      </Layout>
    </>
  );
}